import AnnouncementsOverview from './AnnouncementsOverview'

const ROUTES = [
    AnnouncementsOverview
]

export default ROUTES
